import { useFormContext, useWatch } from "react-hook-form";

import {
  ContentWrapper,
  InputAndLabelWrapper,
  InputRowWrapper,
  SingleColumnWrapper,
} from "../styles";

import YesOrNoQuestion from "./subForms/YesOrNoQuestion";
import RadioQuestion from "./subForms/RadioQuestion";
import { Trans, useTranslation } from "react-i18next";
import {
  AML_COUNTRY_RISK,
  getFulName,
  PEP_CATEGORIES,
  YES_NO_VAL,
} from "./utils";
import { KYC_SCORE } from "../../../LegalForm/steps/step5/utils";
import { useReducer, useState } from "react";
import InfoButton from "../../../../shared/button/InfoButton";
import { InfoModal } from "../../../../shared/modals/InfoModal";
import TextInputWithLanguageControl from "../inputs/TextInputWithLanguageControl";

function Pep(props) {
  const { pepCategory, person, isPep } = props;
  const { exposedPerson, additional, businessRel, familyMember } =
    PEP_CATEGORIES;

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [infoModal, setInfoModal] = useReducer(
    (info, newInfo) => ({ ...info, ...newInfo }),
    { heading: "", body: "" },
  );

  function openModal() {
    setModalIsOpen(true);
  }

  const { t, i18n } = useTranslation();
  const { register, unregister, setValue } = useFormContext();

  const pepCategoryValue = useWatch({ name: "pep.category" });
  const isExposedPerson = Number(pepCategoryValue) === exposedPerson;

  const { name, lastName } = getFulName(i18n.language, person);
  const idNumber = person?.personalNumber;

  const isNameAvailable = name && lastName && isExposedPerson;

  const dualCitizenShipCountryValue = useWatch({
    name: "countryOfCitizenship",
  });
  const isCountryOfHighRiskChosen =
    Number(dualCitizenShipCountryValue?.additionalInfo) === AML_COUNTRY_RISK;

  const economicActivityTypesValue = useWatch({
    name: "economicActivityTypes",
  });

  const hasKycScore = economicActivityTypesValue?.some(
    (item) => item?.kycScore === KYC_SCORE,
  );

  function handleIsPepChange(value) {
    if (Number(value) === YES_NO_VAL.no) {
      unregister("pep");
      if (!isCountryOfHighRiskChosen && !hasKycScore) {
        unregister("kyc");
      }
    }
  }

  function handlePepCategoryChange(e) {
    const value = Number(e.target.value);
    if (value === exposedPerson) {
      if (name && lastName) {
        setValue("pep.name", `${name} ${lastName}`);
      }
      if (idNumber) {
        setValue("pep.idNumber", idNumber);
      }
    } else {
      setValue("pep.name", "");
      setValue("pep.idNumber", "");
    }
    setValue("pep.position", "");
  }

  function handleShowPepInfoClick() {
    openModal();
    setInfoModal({
      heading: t("PEP_meaning"),
      body: (
        <Trans
          i18nKey="PEP_desc"
          components={{ bold: <strong />, lb: <br /> }}
        />
      ),
    });
  }

  const categoryToRender = pepCategory?.filter(
    (item) => item?.value !== additional,
  );

  return (
    <ContentWrapper>
      <YesOrNoQuestion
        label={
          <Trans
            i18nKey="pep_categoryOfPoliticalyExposedPerson"
            components={{ br: <br /> }}
          />
        }
        name="isPep"
        register={register}
        handleChange={(e) => {
          handleIsPepChange(e.target.value);
        }}
        infoButton={
          <InfoButton
            className="ml-2"
            onClick={() => handleShowPepInfoClick()}
          />
        }
      />

      {modalIsOpen ? (
        <InfoModal
          isOpen={modalIsOpen}
          onToggle={() => setModalIsOpen(false)}
          heading={infoModal.heading}
          body={infoModal.body}
        />
      ) : (
        false
      )}
      {isPep ? (
        <>
          <InputRowWrapper>
            <RadioQuestion
              label=""
              name="pep.category"
              data={categoryToRender}
              register={register}
              handleChange={handlePepCategoryChange}
            />
          </InputRowWrapper>

          {pepCategoryValue ? (
            <SingleColumnWrapper>
              <InputAndLabelWrapper>
                <TextInputWithLanguageControl
                  name="pep.name"
                  label={`${t("name")}, ${t("lastName")}`}
                  rules={{ required: t("required") }}
                  disabled={isNameAvailable}
                />
              </InputAndLabelWrapper>

              <InputAndLabelWrapper>
                <TextInputWithLanguageControl
                  name="pep.position"
                  label={t("pep_position")}
                  rules={{ required: t("required") }}
                />
              </InputAndLabelWrapper>
            </SingleColumnWrapper>
          ) : null}
        </>
      ) : null}
    </ContentWrapper>
  );
}
export default Pep;
